import React from 'react'
import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

interface PageLoadingProps {
  tip?: string
}

const PageLoading: React.FC<PageLoadingProps> = ({ tip }) => {
  const { t } = useTranslation('common')
  const displayTip = tip ?? t('loading')

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
      <Spin size="large" />
      <div style={{ marginTop: 16, color: '#999', fontSize: 14 }}>{displayTip}</div>
    </div>
  )
}

export default PageLoading
